/**
 * @generated SignedSource<<fd67dcdaa886f8d07b5fcc0ae164bbfc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useDocsUrl_query$data = {
  readonly UrlConfig: {
    readonly docs: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useDocsUrl_query";
};
export type useDocsUrl_query$key = {
  readonly " $data"?: useDocsUrl_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDocsUrl_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useDocsUrl_query",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UrlConfig",
          "kind": "LinkedField",
          "name": "UrlConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "docs",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d9132a10b96d3c76c8be9b53c15ed55d";

export default node;
